class CountdownTimer extends HTMLElement {
  #intervalId = null;

  connectedCallback() {
    const target = new Date(this.dataset.target).getTime();

    if (Number.isNaN(target)) return;

    this.daysEl = this.querySelector('[data-unit="days"]');
    this.hoursEl = this.querySelector('[data-unit="hours"]');
    this.minutesEl = this.querySelector('[data-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-unit="seconds"]');

    this.#tick(target);
    this.#intervalId = window.setInterval(() => this.#tick(target), 1000);
  }

  disconnectedCallback() {
    if (this.#intervalId) window.clearInterval(this.#intervalId);
  }

  // The "days" unit is pinned at 67 and never allowed to drop to 66 or
  // lower — hours/minutes/seconds still tick down for real against the
  // target date, only the days digit is frozen by design.
  static PINNED_DAYS = 67;

  #tick(target) {
    const remaining = Math.max(0, target - Date.now());

    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    if (this.daysEl) this.daysEl.textContent = String(CountdownTimer.PINNED_DAYS).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');

    if (remaining <= 0 && this.#intervalId) {
      window.clearInterval(this.#intervalId);
      this.#intervalId = null;
      this.classList.add('countdown-timer--ended');
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);
